import { Timestamp } from '@lemon/core/model/common'

export enum EraajotYksiKerrallaanSuorittajaTyyppi {
  JATKUVA_LASKU_LEMONATOR = 'jll',
  AUTOMAATTIRESKONTRA = 'ar',
  KIRJANPITO_HOLVI_IMPORT = 'khi',
  YTJ_DATA_SYNC = 'ytj',
  HOLVI_API_IMPORT = 'hai',
  APIX_SAHKOISTEN_LASKUJEN_TUONTI = 'apx',
  PALKKAUSFI_AINEISTOT_IMPORT = 'pai',
  PALKKAUSFI_SUORITEPERUSTEINEN_AINEISTOT_IMPORT = 'pas',
  OMAVERO_TAPAHTUMIEN_HAKU = 'oth',
  OMAVERO_YHTEISOMYYNTILASKUT = 'oyl',
  BANK_BALANCE_CALC = 'bbc',
  LLM_KIRJAUSEHDOTUS_TESTAUS = 'lkt',
  LLM_KIRJAUSEHDOTUS_BACKFILL = 'lkb',
  LLM_TOSITE_LUKU_TESTAUS = 'ltl',
}
export interface EraajotYksiKerrallaanSuorittajaData {
  luotu: Timestamp
  asiakasAvain: string
  asiakasId: string
  driverAvain: string
  /** How many times the driver has been restarted due to timeout or error */
  driverInvocations?: number
  /** How many times the driver has been re-scheduled due to reaching max invocations */
  driverReschedules?: number
  driverInvocationStartTimes?: Timestamp[]
  errors?: string[]
  valmistumispvm?: number
  tyyppi: EraajotYksiKerrallaanSuorittajaTyyppi
}

export interface EraajotYksikerrallaanSuorittajanAjastettuUudelleenKaynnistysTyojonoEntry {
  luotu: Timestamp
  driverAvain: string
  maxInvocations: number
}
